'use client';

export const ScoreViewSkeleton = () => {
	return (
		<div className="flex w-full flex-col">
			{/* TieBreakerLayout wrapper */}
			<div className="py-9">
				{/* ScoreCardsLayout structure */}
				<div className="flex w-full flex-col">
					<div>
						{/* Title header with optional Substitute button */}
						<div className="w-full flex justify-between items-center">
							<div className="h-6 w-32 animate-pulse rounded bg-gray-200 md:h-8 md:w-40" />
						</div>

						{/* Match Cards Grid */}
						<div className="flex flex-wrap gap-4 justify-start py-6">
							{[...Array(6)].map((_, index) => (
								<div
									key={index}
									className="w-full sm:w-[370px] lg:w-full lg:max-w-[411px] min-h-[494px] my-2 flex rounded-lg bg-white px-4 pt-3 shadow-xs border border-orange-400 cursor-pointer"
								>
									{/* Detailed MatchScoreCard skeleton */}
									<div className="flex flex-col justify-between animate-pulse w-full">
										{/* ScoreCardHeader skeleton */}
										<div className="mb-5 flex items-center justify-between">
											<div className="flex flex-col gap-2 w-full">
												<div className="flex justify-between items-center w-full">
													<div className="h-5 w-32 rounded bg-gray-200 sm:h-6 sm:w-40" />
													{/* Optional cancelled badge */}
													<div className="h-5 w-16 rounded-md bg-gray-200" />
												</div>
												{/* Date and court info */}
												<div className="space-y-1">
													<div className="h-3 w-24 rounded bg-gray-200" />
													<div className="h-3 w-20 rounded bg-gray-200" />
												</div>
											</div>
										</div>

										{/* Main content area */}
										<div className="flex-1">
											{/* Away team block - vertical layout */}
											<div className="mb-4 text-center">
												{/* Team name */}
												<div className="mb-2 flex justify-center">
													<div className="h-6 w-32 rounded bg-gray-200" />
												</div>
												{/* Player 1 */}
												<div className="mb-2 flex justify-center">
													<div className="h-5 w-28 rounded bg-gray-200" />
												</div>
												{/* Player 2 */}
												<div className="mb-2 flex justify-center">
													<div className="h-5 w-28 rounded bg-gray-200" />
												</div>
											</div>

											{/* Score area */}
											<div className="py-4">
												<div className="space-y-2">
													{/* Final scores */}
													{/* <div className="flex justify-center">
														<div className="h-8 w-16 rounded bg-gray-200" />
													</div> */}
													{/* Game scores grid */}
													<div className="grid grid-cols-5 gap-2 sm:max-w-xs mx-auto">
														{[...Array(5)].map((_, i) => (
															<div key={i} className="h-12 rounded bg-gray-200" />
														))}
													</div>
													{/* VS Separator - static content, no skeleton needed */}
													<div className="flex w-full items-center justify-center my-4">
														<div className="w-full border-t border-gray-200 px-2" />
														<div className="px-4 text-gray-300 font-semibold">vs</div>
														<div className="w-full border-t border-gray-200 px-2" />
													</div>
													<div className="grid grid-cols-5 gap-2 sm:max-w-xs mx-auto">
														{[...Array(5)].map((_, i) => (
															<div key={i} className="h-12 rounded bg-gray-200" />
														))}
													</div>
												</div>
											</div>

											{/* Home team block - vertical layout */}
											<div className="mb-4 text-center">
												{/* Team name */}
												<div className="mb-2 flex justify-center">
													<div className="h-6 w-32 rounded bg-gray-200" />
												</div>
												{/* Player 1 */}
												<div className="mb-2 flex justify-center">
													<div className="h-5 w-28 rounded bg-gray-200" />
												</div>
												{/* Player 2 */}
												<div className="mb-2 flex justify-center">
													<div className="h-5 w-28 rounded bg-gray-200" />
												</div>
											</div>
										</div>

										{/* ScoreCardFooter skeleton */}
										<div className="flex bg-gray-100 h-14 px-4 py-2 -mx-4 mt-4 rounded-b-lg justify-between items-center">
											<div className="h-4 w-32 rounded bg-gray-200" />
											<div className="h-6 w-12 rounded bg-gray-200" />
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
